<template>
    <CustomModal modalName="groupSelectionModal" ref="groupSelectionModal" :config="{
        title: 'Selecione um Grupo',
        success: 'Avançar <icon class=&quot;fa-solid fa-arrow-right&quot;></icon>',
        acceptButton: `${!selected ? 'disabled btn-secondary' : 'btn-primary'}`,
        mandatory: true,
    }" @success="$emit('select-group', selectedGroup.label)">
        <div class="d-flex flex-column gap-4 mb-4">
            <img style="height: 120px" src="@/assets/img/select-group.svg" alt="" srcset="" />
            <h6>Com qual grupo deseja fazer login?</h6>
            <DropDownList :config="{ label: '' }" :list="groups" :selectedItem="selectedGroup" @get-item="selectItem" />
        </div>
    </CustomModal>
</template>

<script>
import CustomModal from "@/components/Modal/Modal.vue";
import DropDownList from "../Custom/DropDownList.vue";

export default {
    name: "group-selection-modal",
    components: {
        CustomModal,
        DropDownList,
    },
    emits: ["select-group"],
    data() {
        return {
            selectedGroup: { label: 'Selecione' },
            groups: [],
            selected: false,
        };
    },
    methods: {
        openModal(props) {
            if (props?.groups) this.groups = props.groups;

            this.$refs.groupSelectionModal.openModal();
        },
        selectItem(item) {
            this.selected = true;
            this.selectedGroup = item;
        }
    },
};
</script>